import React, { useEffect } from "react";
import "./Dashboard.css";
import AOS from "aos";
import "aos/dist/aos.css";
const Body = ({ Breadcrumb, title, description, imageUrl }) => {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div className="body-section">
      <div className="row">
        <div className="content" data-aos="fade-right" data-aos-duration="2500">
          {Breadcrumb}

          <h1>{title}</h1>
          <p>{description}</p>
        </div>
        <div className="body">
          <img
            src={imageUrl}
            alt="  Indoor Playground Manufacturer_PROJECT"
            className="hero-image"
          />
        </div>
      </div>
    </div>
  );
};

export default Body;
